export {
  CHARACTER_MAX_RANK_OPTIONS,
  type CorpusSettings,
  corpusSettingsSchema,
  DEFAULT_CORPUS_SETTINGS,
  resolveCorpusSettings,
  SIMPLIFIED_CHARACTER_TIER_OPTIONS,
  type SimplifiedCharacterTier,
  type SimplifiedCorpusSettings,
  TRADITIONAL_CHARACTER_USAGE_OPTIONS,
  type TraditionalCharacterUsage,
  type TraditionalCorpusSettings,
  WORD_MAX_RANK_OPTIONS,
} from "#corpus-settings";
